import { render, staticRenderFns } from "./ProductByFulfillment.vue?vue&type=template&id=71481d60"
import script from "./ProductByFulfillment.vue?vue&type=script&lang=js"
export * from "./ProductByFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports